import classNames from 'classnames'

import {
  EMPTY_OBJECT,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../constants/common'
import { ProfileActionsWidgetExpandAllButton } from '../ProfileActionsWidgetExpandAllButton'
import { ProfileActionsWidgetHideWidgetsButton } from '../ProfileActionsWidgetHideWidgetsButton'
import { ProfileActionsWidgetItem } from '../ProfileActionsWidgetItem'
import { ProfileActionsWidgetSkeleton } from '../ProfileActionsWidgetSkeleton'
import { Widget } from '../Widget'
import { useProfileWidgetsHideContext } from '../Widget.hooks'

import * as styles from './ProfileActionsWidget.module.css'

function ProfileActionsWidget({
  Item = ProfileActionsWidgetItem,
  actions,
  children,
  className,
  contentContainerProps: {
    Skeleton: ContentContainerSkeleton = ProfileActionsWidgetSkeleton,
    className: contentContainerClassName,
    skeletonProps: contentContainerSkeletonProps,
    ...contentContainerProps
  } = EMPTY_OBJECT,
  getItemPropsFromValue,
  isSkeleton,
  onClickAction,
}) {
  const { isWidgetsHidden = false } =
    useProfileWidgetsHideContext() ?? EMPTY_OBJECT

  const itemPlacements = isWidgetsHidden
    ? {
        dropdownPlacement: FLOATING_ELEMENT_PLACEMENT.leftStart,
        tooltipPlacement: FLOATING_ELEMENT_PLACEMENT.left,
      }
    : EMPTY_OBJECT

  const actionsContainerClassName = classNames(styles.actionsContainer, {
    [styles.rail]: isWidgetsHidden,
  })

  return (
    <Widget
      Header={null}
      className={className}
      contentContainerProps={{
        ...contentContainerProps,
        Skeleton: ContentContainerSkeleton,
        className: isWidgetsHidden
          ? styles.railContent
          : contentContainerClassName,
        skeletonProps: isWidgetsHidden
          ? { className: styles.railSkeleton }
          : contentContainerSkeletonProps,
      }}
      isSkeleton={isSkeleton}
    >
      {children}
      <div className={actionsContainerClassName}>
        {actions.map(action => {
          const ItemComponent = action.Component ?? Item

          return (
            <ItemComponent
              {...action}
              {...getItemPropsFromValue?.(action)}
              {...itemPlacements}
              key={action.value}
              onClick={onClickAction}
            />
          )
        })}
        {isWidgetsHidden ? null : (
          <ProfileActionsWidgetExpandAllButton Component={Item} />
        )}
        <ProfileActionsWidgetHideWidgetsButton
          Component={Item}
          tooltipPlacement={itemPlacements.tooltipPlacement}
        />
      </div>
    </Widget>
  )
}

export default ProfileActionsWidget
